// Hands the search text from "Register new patient" to the registration form without
// putting it in the address (search terms are PHI and never go in a URL). Held in memory
// for one read only.

let pending: string | null = null;

export function setRegistrationPrefill(text: string): void {
  pending = text.trim() === '' ? null : text.trim();
}

/** Returns the text once, then forgets it. */
export function takeRegistrationPrefill(): string | null {
  const text = pending;
  pending = null;
  return text;
}
